import { useTranslation } from 'react-i18next'
import { getCurrentBrowser, useReplaceUrlHandler } from '@src/utils/sensor.ts'
import MotionIconSrc from '@static/media/images/permission.motion.svg'
import { isIOS } from '@src/utils/utils.ts'
import { setLocalStorageItem } from '@src/utils/localStorage.ts'
import { useNavigate } from 'react-router-dom'

/** 모션센서 권한 에러 페이지 */
export default function ErrorMotionSensor() {
  // const { t } = useTranslation()
  // useReplaceUrlHandler()
  const navigate = useNavigate()

  return (
    <div
      className={
        'bg-[#0E2153] w-full h-full flex flex-col items-center px-[2rem] pt-[4rem] overflow-y-scroll pb-[1rem]'
      }
    >
      <div className={'font-bold text-[2.4rem] text-white whitespace-pre-wrap text-center'}>
        {'동작 및 방향 센서 접근이\n거부되었습니다.'}
      </div>
      <div className={'text-white pt-[1.6rem] w-[35rem] text-center whitespace-pre-wrap'}>
        {'현재 해당 페이지에서 모션 센서에\n 접근할수 없습니다.'}
        <span className={'text-[#CCFF00] font-bold'}>{' 브라우저앱을 완전히 종료 '}</span>
        {'후\n다시 열어 권한을 허용해주시기 바랍니다.'}
      </div>

      <div className={'border-[0.5px] border-white w-full mt-[3rem] mb-[3rem] max-w-[60rem]'}></div>

      <div className={'flex flex-row items-center gap-5 w-full max-w-[60rem]'}>
        <img src={MotionIconSrc} alt='' className='w-[5rem] h-[5rem] object-contain' />
        <div className={'flex flex-col'}>
          <div className={'text-white font-bold'}>모션 센서</div>
          <div className={'text-white font-light text-[1.4rem]'}>AR 콘텐츠 동작 및 구현</div>
        </div>
      </div>

      <div className={'text-[1.4rem] mt-[4rem] text-white w-full max-w-[60rem] '}>
        만약 브라우저 앱을 종료해도 해결이 안되는 경우, 설정에서 브라우저의 방문 기록 데이터를 지워주시기 바랍니다.
      </div>

      <ol className={'text-[1.4rem] text-white w-full max-w-[60rem] mt-[3rem] list-decimal px-[1.5rem]'}>
        <li className={'mt-[0.5rem]'}>앱을 완전히 종료 후 다시 실행합니다.</li>
        {getCurrentBrowser() === 'safari' ? (
          <>
            <li className={'mt-[0.5rem]'}>그래도 해결이 되지 않는 경우, 아래 방법을 따라주세요.</li>
            <li className={'mt-[0.5rem]'}>{'아이폰 설정 > Safari > 방문 기록 및 웹 사이트 데이터 지우기'}</li>
          </>
        ) : (
          <>
            <li className={'mt-[0.5rem]'}>그래도 해결이 되지 않는 경우, 아래 방법을 따라주세요.</li>
            <li className={'mt-[0.5rem]'}>{'설정 > 개인 정보 보호 및 보안 > 인터넷 사용 기록 삭제'}</li>
          </>
        )}
      </ol>

      <div
        className={
          'w-full flex flex-row justify-center gap-5 mt-[4rem]  portrait:absolute portrait:bottom-[4rem] lg:absolute lg:bottom-[4rem] px-[2rem]'
        }
      >
        <button
          onClick={() => {
            setLocalStorageItem('movedFrom', true)
            navigate(-1)
          }}
          className={'py-[1.1rem] bg-white text-[#0C112A] rounded-small flex-1 max-w-[40rem] font-[500]'}
        >
          홈으로 가기
        </button>
      </div>
    </div>
  )
}
